import React from 'react';
import { Divider, Grid } from '@mui/material';
import { DetailSection, SectionTitle, InfoLabel, InfoValue } from './styles';

interface ShiftDetailsProps {
  shiftCreated: string;
  shiftAccepted: string;
  scheduledDate: string;
  scheduledTime: string;
  experience: string;
  fullNoOfWorkers: string; // e.g. "1/1"
  appointMember: string;
  clockIn: string | null;
  clockOut: string | null;
  totalTimeWorked: string;
  compliantStatus: string;
  payRate: number | null;
  workerSuggestedTime: number | null;
  remarks: string | null;
  isSleepover?: boolean;
  label?: string;
}

const ShiftDetails: React.FC<ShiftDetailsProps> = ({
  shiftCreated,
  shiftAccepted,
  scheduledDate,
  scheduledTime,
  experience,
  fullNoOfWorkers,
  appointMember,
  clockIn,
  clockOut,
  totalTimeWorked,
  compliantStatus,
  payRate,
  workerSuggestedTime,
  remarks,
  isSleepover,
  label
}) => {
  return (
    <>
      <DetailSection>
        <SectionTitle>Shift Details</SectionTitle>
        <Grid container spacing={3}>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Shift Created</InfoLabel>
            <InfoValue>{shiftCreated}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Shift Accepted</InfoLabel>
            <InfoValue>{shiftAccepted}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Scheduled Date</InfoLabel>
            <InfoValue>{scheduledDate}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Scheduled Time</InfoLabel>
            <InfoValue>{scheduledTime}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Experience</InfoLabel>
            <InfoValue>{experience}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>No of Workers</InfoLabel>
            <InfoValue>{fullNoOfWorkers}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Label</InfoLabel>
            <InfoValue>{label || '-'}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Sleepover</InfoLabel>
            <InfoValue>{isSleepover ? 'Yes' : 'No'}</InfoValue>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <InfoLabel>Appoint Member</InfoLabel>
            <InfoValue>{appointMember}</InfoValue>
          </Grid>
          {remarks && (
            <Grid size={{ xs: 12 }}>
              <InfoLabel>Remarks</InfoLabel>
              <InfoValue>{remarks}</InfoValue>
            </Grid>
          )}
        </Grid>
      </DetailSection>
      <Divider variant="middle" />
      <DetailSection>
        <SectionTitle>Shift Work Details</SectionTitle> {/* Repeating title as per design mock */}
        <Grid container spacing={3}>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Clock In</InfoLabel>
            <InfoValue>{clockIn}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Clock Out</InfoLabel>
            <InfoValue>{clockOut}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Total Time Worked</InfoLabel>
            <InfoValue>{totalTimeWorked}</InfoValue>
          </Grid>
          <Grid size={{ xs: 6, md: 6 }}>
            <InfoLabel>Compliant Status</InfoLabel>
            <InfoValue>{compliantStatus}</InfoValue>
          </Grid>
          {/* {payRate &&
            <Grid size={{ xs: 6, md: 6 }}>
              <InfoLabel>Pay Rate</InfoLabel>
              <InfoValue>{`$${payRate}`}</InfoValue>
            </Grid>
          } */}
          {workerSuggestedTime &&
            <Grid size={{ xs: 6, md: 6 }}>
              <InfoLabel>Worker Suggested Time</InfoLabel>
              <InfoValue>{workerSuggestedTime}</InfoValue>
            </Grid>
          }
        </Grid>
      </DetailSection>
    </>
  );
};

export default ShiftDetails;
